import { ZUid } from "src/types/zUid";
import { parseFormulaArguments } from "./parseFormulaArguments";

export const replaceFormulaDependencyIds = (
  formula: string,
  replacements: Readonly<Record<string, ZUid>>,
): string => {
  let result = "";
  let position = 0;
  // Все позиции относятся к исходной формуле: новый ID не заменяется повторно.
  parseFormulaArguments(formula).forEach(
    ({ text, index, linkId, attributeId }) => {
      const dependencyId = linkId ?? attributeId;
      const newId = replacements[dependencyId];
      const replacement =
        newId === undefined
          ? text
          : `${text[0]}${newId}${text.slice(dependencyId.length + 1)}`;
      result += formula.slice(position, index) + replacement;
      position = index + text.length;
    },
  );
  return result + formula.slice(position);
};
